import { createSlice } from '@reduxjs/toolkit'

export const currenciesSlice = createSlice({
  name: 'currencies',
  initialState: {
    value: []
  },
  reducers: {
    setCurrencies: (state, payload) => {
      state.value = payload.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const { setCurrencies } = currenciesSlice.actions

export default currenciesSlice.reducer